import { render, staticRenderFns } from "./advertisement.vue?vue&type=template&id=2a42e378&scoped=true"
import script from "./advertisement.vue?vue&type=script&lang=js"
export * from "./advertisement.vue?vue&type=script&lang=js"
import style0 from "./advertisement.vue?vue&type=style&index=0&id=2a42e378&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a42e378",
  null
  
)

export default component.exports